import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ngfModule, ngf } from "angular-file";
import { CatalogsService } from '../../services/catalogs/catalogs.service';
import { Validators, FormGroup, FormBuilder } from "@angular/forms";

@Component({
  selector: 'app-add-reg',
  templateUrl: './add-reg.component.html',
  styleUrls: ['./add-reg.component.scss']
})
export class AddRegComponent implements OnInit {

  @Input() modulo;

  public regMonedaForm: FormGroup;
  public submitted: Boolean = false;
  public error = null;
  constructor(
    public activeModal: NgbActiveModal,
    public catalogService: CatalogsService,
    private formBuilder: FormBuilder



  ) { }

  ngOnInit() {
    this.regMonedaForm = this.formBuilder.group({
      codigo: ['', Validators.required],
      identificador: ['', Validators.required],
    })
  }


  closeModal() {
    this.activeModal.close('x');
  }


  public submitMoneda(): void {
    // console.log("trying to do add " +this.modulo);
    this.submitted = true;
    this.error = null;
    let tipo = this.modulo;
    if (this.regMonedaForm.valid) {
      this.catalogService.crearMonedas(this.regMonedaForm.value,tipo).subscribe(
        data => {
          if (data != null) {
             this.activeModal.close(data.result);
            }
          
        //  console.log(resp.headers.get('Cookie'));
        },
        error => {
          // console.log(error);
          this.error = error
        }
      )
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/components/add-reg/add-reg.component.ts